import { ANIMATION_IDENTIFIERS } from '@Animation/types'
import { AppSettings, GAME_SPEED } from './types'

export const MOCK_APP_SETTINGS: AppSettings = {
  animationsEnabled: [{ identifier: ANIMATION_IDENTIFIERS.CYBER_SNAKES, isEnabled: true }],
  autoPlay: false,
  gameSpeed: GAME_SPEED.SLOW,
  soundEnabled: false,
}
